import React, { useRef, useState, useEffect, useMemo } from "react";
import Button from "@mui/material/Button";
import MGridForm from "components/Shared/MGridForm";
import { 
  DATA_TYPE_DATE, 
} from "typeConstants/dataTypes";
import validator from "components/Shared/MGridFormDefinitions/validator";

export interface NewDueDateEntryForm {
  currentDueDate: string;
  newDueDate: string;
}

interface EditNotificationDueDateDialogProps {
  data: NewDueDateEntryForm;
  onCancel: () => void;
  onSave: (data: NewDueDateEntryForm) => void;
}

const EditNotificationDueDateDialog = (props: EditNotificationDueDateDialogProps) => {
  const [dueDateData, setDueDateData] = useState<NewDueDateEntryForm>(props.data);
  const formControlMethods = useRef({});  // TODO Add type when MGridForm has interfaces

  useEffect(() => {
    if (JSON.stringify(props.data) !== JSON.stringify(dueDateData)) {
      setDueDateData(props.data);
    }
  }, [props.data]);

  const handleSave = () => {
    if (formControlMethods.current.isFormValid()) {
      props.onSave(dueDateData);
    }
  };

  const handleFormChange = (updatedObject: NewDueDateEntryForm) => {
    setDueDateData({ ...updatedObject });
  };

  const formDefinition = useMemo(() => {
    let mGridFormDefinition = [ 
      [
        { dataType: DATA_TYPE_DATE, label: "New Due Date", source: "newDueDate", hasValidationError: validator.required }
      ],
    ];

    return mGridFormDefinition;
  }, []); 

  return (
    <>
      <div>Current Due Date: {props.data.currentDueDate}</div>
      <MGridForm
        width={500}
        data={dueDateData}
        onChange={handleFormChange}
        formDefinition={formDefinition}
        portalTarget={() => document.querySelector(".add-edit-notification-due-date-dialog")}
        getControlMethods={cm => { formControlMethods.current = cm; }}
        webform
      />
      <div className="button-row">
        <Button key={"due-date-cancel-delete"} onClick={props.onCancel} >Cancel</Button>
        <Button key={"due-date-confirm-delete"} onClick={handleSave} >Save</Button>
      </div>
    </>
  );
};

export default EditNotificationDueDateDialog;